<template>
  <div id="bd-rtc">
    <!-- rtc {{ thread.nickname }} -->
    <div id="videos">
      <!-- 访客视频 -->
      <video id="remoteVideo" autoplay playsinline style="width: 274px;"></video>
      <!-- 本地客服视频 -->
      <video id="localVideo" autoplay muted playsinline style="width: 74px;"></video>
      <!-- 录制视频 -->
      <video id="recordedVideo" playsinline loop style="width: 274px;" v-if="showRecordPlayButton"></video>
      <p v-if="isRecording">视频录制中</p>
      <p v-if="isRecorded">视频录制结束，请点击播放按钮</p>
      <!-- 截图画布 -->
      <canvas style="width: 250px;" v-if="showCaptureDownloadButton"></canvas>
    </div>
    <div id="audios" style="display: none;">
      <audio id="remoteAudio" controls autoplay></audio>
    </div>
    <div id="videoButtons" style="text-align: center;">
      <!-- TODO: 截图、录屏、录音并上传服务器保存 -->
      <el-button size="small" @click="captureImage" round v-if="showCaptureButton">截屏</el-button>
      <el-button size="small" @click="downloadImage" round v-if="showCaptureDownloadButton">下载截图</el-button>
      <el-button size="small" @click="startRecordVideo" round v-if="showRecordStartButton">开始录像</el-button>
      <el-button size="small" @click="stopRecordVideo" round v-if="showRecordStopButton">结束录像</el-button>
      <el-button size="small" @click="playRecordedVideo" round v-if="showRecordPlayButton">播放录像</el-button>
      <el-button size="small" @click="downloadRecordedVideo" round v-if="showRecordDownloadButton">下载录像</el-button>
      <el-button size="small" @click="doHangUpCall" round v-if="showHangupButton">结束会话</el-button>
      <!-- <el-select v-model="currentCodecValue" placeholder="请选择" size="mini">
        <el-option
          v-for="item in codecOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-rtc',
  data () {
    return {
      'test': '',
      thread: {
        nickname: 'waiting'
      },
      // 截图canvas
      captureCanvas: null,
      // 录像
      mediaRecorder: null,
      recordedBlobs: [], // 存放录像数据
      isRecording: false, // 是否正在录像中
      isRecorded: false, // 是否录像完成
      // 接收图片服务器地址
      uploadImageServerUrl: constants.UPLOAD_IMAGE_URL_V2,
      uploadFileServerUrl: constants.UPLOAD_FILE_URL,
      uploadVoiceServerUrl: constants.UPLOAD_VOICE_URL,
      // 
      // codecOptions: [],
      currentCodecValue: '',
      // webrtc会话相关
      audioStreamConstraints: {
        audio: true,
        video: false
      },
      audioOfferSdpConstraints: {
        offerToReceiveAudio: true,
        offerToReceiveVideo: false
      },
      videoStreamConstraints: {
        audio: true,
        video: true
        // audio: {
        //   echoCancellation: { exact: true }
        // },
        // video: {
        //   width: 1280, height: 720
        // }
      },
      videoOfferSdpConstraints: {
        offerToReceiveAudio: true,
        offerToReceiveVideo: true
      },
      // 为计算接通时长,记录开始情况会话时间戳
      rtcStartCallTimestamp: null,
      // 是否rtc会话发起者
      // isRtcInitiator: false,
      // rtc会话是否成功开始
      // isRtcStarted: false,
      // 会话窗口是否显示
      // rtcDialogVisible: false,
      rtcPeerConnection: null,
      // 视频窗口
      rtcLocalVideo: null,
      rtcRemoteVideo: null,
      recordedVideo: null,
      // 视频流
      rtcLocalStream: null,
      rtcRemoteStream: null,
      // 本地candidate信息
      // rtcIceCandidate: null
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'isWebrtcStarted']),
    showCaptureButton() {
      return !!this.rtcRemoteStream
    },
    showCaptureDownloadButton() {
      return !!this.rtcRemoteStream && this.captureCanvas
    },
    showRecordStartButton() {
      return !!this.rtcRemoteStream && !this.isRecording
    },
    showRecordStopButton() {
      return !!this.rtcRemoteStream && this.isRecording
    },
    showRecordPlayButton() {
      return !this.isRecording && this.isRecorded
    },
    showRecordDownloadButton() {
      return !this.isRecording && this.isRecorded
    },
    showHangupButton() {
      return !!this.rtcRemoteStream
    }
  },
  methods: {
    ...mapActions('mqtt', ['sendMessageProtobuf']),
    ...mapActions(['updateWebrtcStarted', 'agentCloseThread', 'removeClosedThread',]),
    //
    captureImage() {
      // console.log('capture && save image')
      if (this.rtcRemoteVideo) {
        // 截屏初始化
        this.captureCanvas = document.querySelector('canvas')
        this.captureCanvas.width = this.rtcRemoteVideo.videoWidth;
        this.captureCanvas.height = this.rtcRemoteVideo.videoHeight;
        this.captureCanvas.getContext('2d').drawImage(this.rtcRemoteVideo, 0, 0, this.captureCanvas.width, this.captureCanvas.height);
      } else {
        console.log('rtcRemoteVideo is null')
      }
    },
    downloadImage() {
      let urlData = this.captureCanvas.toDataURL("image/jpeg", 1)
      var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte  
      //处理异常,将ascii码小于0的转换为大于0  
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: 'image/jpeg' });
      let filename = moment(new Date()).format("YYYYMMDDHHmmss");
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename + '.png';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    },
    startRecordVideo() {
      this.recordedVideo = document.getElementById('recordedVideo')
      this.isRecording = true
      this.isRecorded = false
      // console.log('start record && save video')
      this.recordedBlobs = [];
      const mimeType = this.currentCodecValue;
      const options = { mimeType };
      try {
        this.mediaRecorder = new MediaRecorder(this.rtcRemoteStream, options);
      } catch (e) {
        console.error('Exception while creating MediaRecorder:', e);
        return;
      }
      console.log('Created MediaRecorder', this.mediaRecorder, 'with options', options);
      // recordButton.textContent = 'Stop Recording';
      // playButton.disabled = true;
      // downloadButton.disabled = true;
      // codecPreferences.disabled = true;
      this.mediaRecorder.onstop = (event) => {
        console.log('Recorder stopped: ', event);
        console.log('Recorded Blobs: ', this.recordedBlobs);
      };
      this.mediaRecorder.ondataavailable = this.handleDataAvailable;
      this.mediaRecorder.start();
      console.log('MediaRecorder started', this.mediaRecorder);
    },
    stopRecordVideo () {
      console.log('stop record && save videoo')
      this.mediaRecorder.stop();
      this.isRecording = false
      this.isRecorded = true
    },
    playRecordedVideo() {
      const mimeType = this.currentCodecValue.split(';', 1)[0];
      const superBuffer = new Blob(this.recordedBlobs, { type: mimeType });
      this.recordedVideo.src = null;
      this.recordedVideo.srcObject = null;
      this.recordedVideo.src = window.URL.createObjectURL(superBuffer);
      this.recordedVideo.controls = true;
      this.recordedVideo.play();
    },
    downloadRecordedVideo() {
      let filename = moment(new Date()).format("YYYYMMDDHHmmss");
      const blob = new Blob(this.recordedBlobs, {type: 'video/webm'});
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename + '.webm';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    },
    // 用于替换客服端摄像头，使得在访客端显示此设定图片，而非客服本人
    drawImageOnCanvas() {
      // <canvas id="cv" width="600" height="600"></canvas>
      //1. 获取canvas元素
      var cv = document.getElementById("cv");
      //2. 获取2D上下文
      var ctx = cv.getContext('2d');
      //3. 新建一个Image对象
      var img = new Image();
      //4. 设置Image的src
      img.src = this.userInfo.avatar;
      //5. 确定Image加载完毕后将Image画到canvas上
      img.onload = () => {
          ctx.drawImage(img, 0, 0, 400, 400);
      }
    },
    /**
     * 参考网址:
     * https://webrtc.github.io/samples/
     * https://codelabs.developers.google.com/codelabs/webrtc-web/#4
     * https://cloud.tencent.com/developer/article/1004661
     * https://www.html5rocks.com/en/tutorials/webrtc/infrastructure/
     * 开始视频会话：(发送信息部分均调用自定义消息接口)
     * 1. A发起offer: 首先调用setLocalDescription设置自己的SDP，然后将SDP发送给B
     * 2. B收到offer之后，首先将A的SDP调用setRemoteDescription保存
     * 3. B执行answer：首先调用setLocalDescription设置自己的SDP，然后将SDP发送给A
     * 4. A收到B的SDP之后调用setRemoteDescription保存
     * 5. A初始化本地摄像头，并创建peerConnection, 发送candidate信息给对方B，即：自己的ip等信息
     * 6. B收到消息之后也开始初始化摄像头, 并创建peerConnection, 发送candidate信息给对方A
     * 7. B收到A的candidate信息后，执行addIcecandidate; A收到B的candidate信息后，执行addIcecandidate
     * 连接建立
     * 
     * 实际流程：
     * 1. 访客端初始化本地摄像头，创建peerconnection，监听icecandidate。发起请求会话
     * 2. 客服端接收到webrtc_invite消息
     * 3. 客服端初始化本地摄像头，创建peerconnection，监听icecandidate
     * 4. 客服端createOffer设置local sdp并将此sdp发送给访客端，访客端设置remote sdp
     * 5. 访客端createAnswer设置local sdp并将此sdp发送给客服端，客服端设置remote sdp
     * 6. 访客端或者客服端将监听到的本地icecandidate发送给对方，对方收到之后addicecandidate
     */
    acceptVideoCall () {
      // this.rtcStartCallTimestamp = window.performance.now()
      // this.isRtcInitiator = true
      // 更新视频客服状态为占用
      this.updateWebrtcStarted(true)
      // 初始化
      this.initLocalStream()
      this.initRemoteStream()
    },
    // 本地设备初始化
    initLocalStream () {
      console.log('initLocalStream')
      //
      let app = this
      this.rtcLocalVideo = document.getElementById('localVideo')
      this.rtcLocalVideo.addEventListener('loadedmetadata', event => {
        const video = event.target
        console.log(`本地视频窗口 ${video.id} videoWidth: ${video.videoWidth}px, ` + `videoHeight: ${video.videoHeight}px.`)
        app.sendReadyMessage()
      })
      //
      navigator.mediaDevices.getUserMedia(this.videoStreamConstraints).then(mediaStream => {
        app.rtcLocalStream = mediaStream
        app.rtcLocalVideo.srcObject = mediaStream
        mediaStream.oninactive = function() {
          console.log('Stream ended');
        };
        // mediaStream.getVideoTracks()[0].addEventListener('ended', () => {
        //   console.log('The user has ended sharing the screen');
        // });
        // 创建连接，并发送ice candidate信息
        app.createPeerConnection()
        // Added local stream to localPeerConnection
        // app.rtcPeerConnection.addStream(mediaStream)
      }).catch(error => {
        console.log('getUserMedia() error: ' + error)
      })
    },
    initRemoteStream () {
      //
      this.rtcRemoteVideo = document.getElementById('remoteVideo')
      this.rtcRemoteVideo.addEventListener('loadedmetadata', event => {
        const video = event.target
        console.log(`远程视频窗口 ${video.id} videoWidth: ${video.videoWidth}px, ` + `videoHeight: ${video.videoHeight}px.`)
      })
      this.rtcRemoteVideo.addEventListener('onresize', event => {
        // This event is fired when video begins streaming.
        const video = event.target
        console.log(`接通远程视频 remote resize ${video.id} videoWidth: ${video.videoWidth}px, ` + `videoHeight: ${video.videoHeight}px.`)
      })
    },
    /**
     * 创建连接
     */
    createPeerConnection () {
      console.log('createPeerConnection')
      try {
        let app = this
        // const configuration = null // Allows for RTC server configuration.
        // const configuration = {
        //   'iceServers': [
        //     { 'url': 'stun:stun.l.google.com:19302' },
        //     {
        //       'url': 'turn:api.bytedesk.com:3478?transport=udp',
        //       'credential': '123456',
        //       'username': 'jackning'
        //     },
        //     {
        //       'url': 'turn:api.bytedesk.com:3478?transport=tcp',
        //       'credential': '123456',
        //       'username': 'jackning'
        //     }
        //   ]
        // }
        const configuration = {
            iceServers: [{
                urls: "turn:turn.bytedesk.com:3478",
                username: "jackning",
                credential: "kX1JiyPGVTtO3y0o"
            }]
        };
        this.rtcPeerConnection = new RTCPeerConnection(configuration)
        // 调用createOffer，设置setLocalDescription之后才会调用onicecandidate
        // The PeerConnection won't start gathering candidates until you call setLocalDescription();
        this.rtcPeerConnection.onicecandidate = function (event) {
        // this.rtcPeerConnection.addEventListener('icecandidate', event => {
          // console.log('onicecandidate event: ', event)
          // const peerConnection = event.target
          // const iceCandidate = event.candidate
          // app.isRtcStarted = true
          // 发送自己candidate信息给对方
          if (event.candidate !== null && event.candidate !== undefined) {
            let candidateObject = { sdp: event.candidate.candidate, sdpMLineIndex: event.candidate.sdpMLineIndex, sdpMid: event.candidate.sdpMid }
            app.sendCandidateMessage(candidateObject)
          }
        }
        this.rtcPeerConnection.oniceconnectionstatechange = function (event) {
          console.log('iceconnectionstatechange: ', event)
        }
        this.rtcPeerConnection.onaddstream = function (event) {
          console.log('Remote stream added.')
          app.rtcRemoteStream = event.stream
          app.rtcRemoteVideo.srcObject = event.stream
        }
        this.rtcPeerConnection.onremovestream = function (event) {
          console.log('Remote stream removed. Event: ', event)
        }
        console.log('Created RTCPeerConnnection')
        this.rtcPeerConnection.addStream(this.rtcLocalStream)
        // 
        this.createRtcOffer()
      } catch (error) {
        console.log('Failed to create PeerConnection, exception: ' + error.message)
      }
    },
    // 发送webrtc Offer
    createRtcOffer () {
      console.log('createRtcOffer')
      let app = this
      this.rtcPeerConnection.createOffer(this.videoOfferSdpConstraints).then(sessionDescription => {
        // 将SDP保存本地
        app.rtcPeerConnection.setLocalDescription(sessionDescription).then(() => {
          console.log('offer set localDescription success:', sessionDescription)
          // 将SDP发送给对方
          app.sendOfferMessage(sessionDescription)
        }, error => {
          console.log('offer set localDescription error: ', error)
        })
      }, error => {
        console.log('createOffer error: ', error)
      })
    },
    // 发送webrtc answer
    // createRtcAnswer () {
    //   console.log('createRtcAnswer')
    //   let app = this
    //   this.rtcPeerConnection.createAnswer().then(sessionDescription => {
    //     // 将SDP保存本地
    //     app.rtcPeerConnection.setLocalDescription(sessionDescription).then(() => {
    //       console.log('answer set localDescription success:', sessionDescription)
    //       // 将SDP发送给对方
    //       app.sendAnswerMessage(sessionDescription)
    //     }, error => {
    //       console.log('answer set localDescription error: ', error)
    //     })
    //   }, error => {
    //     console.log(error)
    //   })
    // },
    // 结束会话
    doHangUpCall() {
      // 更新视频客服状态为非占用
      this.updateWebrtcStarted(false)
      // 挂断
      this.hangUpCall()
      // 发送结束会话信息
      this.sendCloseMessage()
      //
      let tid = this.thread.tid
      // 从会话列表移除
      this.removeClosedThread(tid)
      // 向服务器发送关闭会话通知
      this.agentCloseThread(tid)
    },
    hangUpCall () {
      console.log('hangUpCall')
      if (this.rtcPeerConnection !== null && this.rtcPeerConnection !== undefined && this.rtcLocalStream) {
        // 结束视频流
        this.rtcPeerConnection.close()
        this.rtcPeerConnection = null
        // 关闭摄像头
        // this.rtcLocalStream.getTracks().forEach(track => track.stop());
        this.rtcLocalStream.getAudioTracks()[0].stop()
        this.rtcLocalStream.getVideoTracks()[0].stop()
        // 
        this.rtcLocalStream = null
        this.rtcRemoteStream = null
        // 关闭对话框
        // this.rtcDialogVisible = false
      }
      // 标记会话结束
      // this.isRtcStarted = false
    },
    // 通知对方初始化视频设备
    // sendInviteMessage () {
    //   console.log('sendInviteMessage')
    //   let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_INVITE, content: '视频会话邀请', thread: this.thread }
    //   this.sendMessageProtobuf(payload)
    // },
    // 将本地ice candidate信息发送给对方
    sendCandidateMessage (candidate) {
      // console.log('sendCandidateMessage: ', candidate)
      let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CANDIDATE, content: JSON.stringify(candidate), thread: this.thread }
      this.sendMessageProtobuf(payload)
    },
    // 将SDP发送给对方
    sendOfferMessage (sessionDescription) {
      // console.log('send offer sessionDescription:', sessionDescription)
      let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_OFFER_VIDEO, content: JSON.stringify(sessionDescription), thread: this.thread }
      this.sendMessageProtobuf(payload)
    },
    // 将SDP发送给对方
    // sendAnswerMessage (sessionDescription) {
    //   console.log('send answer sessionDescription:', sessionDescription)
    //   let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_ANSWER, content: JSON.stringify(sessionDescription), thread: this.thread }
    //   this.sendMessageProtobuf(payload)
    // },
    // 发送接受视频邀请信息
    // sendAcceptMessage () {
    //   console.log('send accept rtc')
    //   let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_ACCEPT, content: '接受视频会话', thread: this.thread }
    //   this.sendMessageProtobuf(payload)
    // },
    // 发送拒绝视频邀请信息
    // sendRejectMessage () {
    //   console.log('send reject rtc')
    //   let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_REJECT, content: '拒绝视频会话', thread: this.thread }
    //   this.sendMessageProtobuf(payload)
    // },
    // 被邀请方视频设备 + peeConnection已经就绪
    sendReadyMessage () {
      // console.log('send ready rtc')
      let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_READY, content: '视频就绪', thread: this.thread }
      this.sendMessageProtobuf(payload)
    },
    // 视频会话忙信息
    sendBusyMessage () {
      // console.log('send busy rtc')
      let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_BUSY, content: '对方忙', thread: this.thread }
      this.sendMessageProtobuf(payload)
    },
    // 关闭视频会话信息
    sendCloseMessage () {
      // console.log('send close rtc')
      let payload = { type: constants.MESSAGE_TYPE_NOTIFICATION_WEBRTC_CLOSE, content: '关闭视频会话', thread: this.thread }
      this.sendMessageProtobuf(payload)
    },
    // 上传图片
    uploadImage(file) {
      // console.log('uploadImage')
      let app = this
      this.compressImage(file, function (newFile) {
        // 
        let filename = moment(new Date()).format("YYYYMMDDHHmmss");
        var formdata = new FormData();
        formdata.append("file_name", filename);
        formdata.append("username", app.userInfo.username);
        formdata.append("file", newFile);
        formdata.append("client", "web");
        //
        $.ajax({
            url: app.uploadImageServerUrl,
            contentType: false,
            cache: false,
            processData: false,
            mimeTypes: "multipart/form-data",
            type: "post",
            data: formdata,
            success: function (response) {
                console.log('upload response:' + JSON.stringify(response.data))
                // var imageUrl = response.data;
                // app.sendImageMessage(imageUrl);
            },
            error: function (error) {
                console.log(error);
                // token过期
                app.login()
            }
        });
      })
    },
    // 上传并发送文件
    uploadFile(file) {
      // TODO: 先在界面显示文件，并显示上传loading
      let filename = moment(new Date()).format("YYYYMMDDHHmmss");
      var formdata = new FormData();
      formdata.append("file_name", filename);
      formdata.append("username", this.userInfo.username);
      formdata.append("file", file);
      formdata.append("client", "web");
      //
      $.ajax({
          url: this.uploadFileServerUrl,
          contentType: false,
          cache: false,
          processData: false,
          mimeTypes: "multipart/form-data",
          type: "post",
          data: formdata,
          success: function (response) {
              console.log('upload response:' + JSON.stringify(response.data))
              // var fileUrl = response.data;
              // app.sendFileMessage(fileUrl);
          },
          error: function (error) {
              console.log(error);
          }
      });
    },
    compressImage(file, callback) {
      // 判断文件大小
      if (file.size > 1024 * 1024 * 1) {
        this.canvasDataURL(file, function (blob) {
          //
          var newFile = new File([blob], file.name, {
              type: file.type
          })
          console.log('file.size:' + (file.size / 1024 / 1024))
          console.log('newFile.size: ' + (newFile.size / 1024 / 1024))
          // 
          if (file.size < newFile.size) {
              callback(file)
          }
          callback(newFile)
        })
      } else {
        console.log('图片小于1M直接上传')
        return callback(file)
      }
    },
    // 图片压缩方法
    canvasDataURL(file, callback) {
      let app = this
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        const img = new Image()
        const quality = 0.1 // 图像质量
        const canvas = document.createElement('canvas')
        const drawer = canvas.getContext('2d')
        img.src = this.result
        img.onload = function () {
          canvas.width = img.width
          canvas.height = img.height
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
          return app.convertBase64UrlToBlob(canvas.toDataURL("image/jpeg", quality), callback);
        }
      }
    },
    // 将以base64的图片url数据转换为Blob
    convertBase64UrlToBlob(urlData, callback) {
      // 
      var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte  
      //处理异常,将ascii码小于0的转换为大于0  
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: 'image/jpeg' });
      // 
      callback(blob)
    },
    handleDataAvailable(event) {
      // console.log('handleDataAvailable', event);
      if (event.data && event.data.size > 0) {
        this.recordedBlobs.push(event.data);
      }
    },
    getSupportedMimeTypes() {
      const possibleTypes = [
        'video/webm;codecs=vp9,opus',
        'video/webm;codecs=vp8,opus',
        'video/webm;codecs=h264,opus',
        'video/mp4;codecs=h264,aac',
      ];
      // return possibleTypes.filter(mimeType => {
      //   return MediaRecorder.isTypeSupported(mimeType);
      // });
      let supportedTypes = possibleTypes.filter(mimeType => {
        return MediaRecorder.isTypeSupported(mimeType);
      });
      if (supportedTypes.length > 0) {
        this.currentCodecValue = supportedTypes[0]
      }
    }

  },
  mounted() {
    // 本地消息通知
    bus.$on(constants.EVENT_BUS_WEBRTC_ACCEPT, message => {
      console.log('rtc eventbus:', message)
      this.thread = message.thread
      this.acceptVideoCall()
    })
    // // webrtc邀请视频会话
    // bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_OFFER_VIDEO, message => {
    //   console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_OFFER_VIDEO:', message)
    //   // 邀请者发送offer，被邀请者接收offer并发送answer
    //   // if (!this.isRtcInitiator) {
    //   let sessionDescription = message.content
    //   // console.log('sdp:', sessionDescription)
    //   let msgSDP = JSON.parse(sessionDescription)
    //   let sessionDescriptionJson = { type: msgSDP.type.toLowerCase(), sdp: msgSDP.sdp }
    //   //
    //   this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription(sessionDescriptionJson))
    //   this.createRtcAnswer()
    //   // }
    // })
    // // webrtc邀请音频会话
    // // TODO: 弹出提示窗，客服点击接受之后，才能够 setRemoteDescription 和 answer
    // bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_OFFER_AUDIO, message => {
    //   console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_OFFER_AUDIO:', message)
    //   // 邀请者发送offer，被邀请者接收offer并发送answer
    //   // if (!this.isRtcInitiator) {
    //   let sessionDescription = message.content
    //   if (sessionDescription !== null && sessionDescription !== undefined) {
    //     this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription(sessionDescription))
    //     this.createRtcAnswer()
    //   }
    //   // }
    // })
    // 接受webrtc邀请
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_ANSWER, message => {
      console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_ANSWER:', message)
      // 邀请者处理收到并处理被邀请者发送过来的answer
      let sessionDescription = JSON.parse(message.content)
      if (sessionDescription !== null && sessionDescription !== undefined) {
        this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription(sessionDescription))
      }
    })
    // webrtc candidate信息
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_CANDIDATE, message => {
      console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_CANDIDATE:', message)
      // FIXME: Failed to execute 'setRemoteDescription' on 'RTCPeerConnection': Failed to set remote answer sdp: Called in wrong state: stable
      // 接收并处理对方的candidate信息
      let candidate = JSON.parse(message.content)
      if (candidate !== null && candidate !== undefined) {
        // const newIceCandidate = new RTCIceCandidate(candidate);
        let newIceCandidate = { candidate: candidate.sdp, sdpMLineIndex: candidate.sdpMLineIndex, sdpMid: candidate.sdpMid }
        // So there, you can't add ICE candidates without setting remote description
        // https://stackoverflow.com/questions/38198751/domexception-error-processing-ice-candidate
        if (this.rtcPeerConnection && this.rtcPeerConnection.remoteDescription) {
          this.rtcPeerConnection.addIceCandidate(newIceCandidate)
            .then(() => {
                console.log('addIceCandidate success')
            }).catch((error) => {
                console.log('addIceCandidate:', error)
            });
        }
      }
    })
    // 接受webrtc邀请
    // bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_ACCEPT, message => {
    //   console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_ACCEPT:', message)
    //   // 对方接受视频邀请
    //   // if (this.isRtcInitiator) {
    //   //   //
    //   // }
    // })
    // 拒绝webrtc邀请
    // bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_REJECT, message => {
    //   console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_REJECT:', message)
    //   this.hangUpCall()
    //   // this.isRtcInitiator = false
    // })
    // 对方视频设备 + peeConnection已经就绪
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_READY, message => {
      console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_READY:', message)
      // 被邀请者设备连接ready
      // 邀请者收到被邀请者的视频连接已经就绪的消息之后，开始发送sdp信息
      // if (this.isRtcInitiator) {
      // this.createRtcOffer()
      // }
    })
    // webrtc忙线
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_BUSY, message => {
      console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_BUSY:', message)
      this.hangUpCall()
      // this.isRtcInitiator = false
    })
    // 结束webrtc会话
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_CLOSE, message => {
      console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_CLOSE:', message)
      this.hangUpCall()
      // this.isRtcInitiator = false
    })
    bus.$on(constants.EVENT_BUS_MESSAGE_WEBRTC_CANCEL, message => {
      console.log('rtc EVENT_BUS_MESSAGE_WEBRTC_CANCEL:', message)
      this.hangUpCall()
      // this.isRtcInitiator = false
    })
    this.getSupportedMimeTypes()
    // let app = this
    // this.getSupportedMimeTypes().forEach(mimeType => {
    //   // console.log('getSupportedMimeTypes')
    //   app.codecOptions.push({
    //     value: mimeType,
    //     label: mimeType
    //   })
    // });
  }
}
</script>

<style scoped>
#bd-rtc {
  width: 100%;
  height: 100%;
}
</style>
